import { CommonModule } from "@angular/common";
import { Component, inject, input, Input } from "@angular/core";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatExpansionModule } from "@angular/material/expansion";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  firstValueFrom,
  Observable,
  shareReplay,
  skipWhile,
  Subscription,
  take,
  withLatestFrom,
} from "rxjs";
import { IAcuerdoSeleccionado } from "../../../interfaces/acuerdos";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../../app.state";
import {
  selectDespachoActual,
  selectDespachoEntradas,
  selectDespachoState,
  selectDespachosTodos,
  selectGuardandoDespacho,
  selectSaveDespacho,
  selectTipoDespachoExpandido,
} from "../../../states/despacho/selector";
import {
  IDespacho,
  IInfoVoboDespacho,
  Informativo,
  VoBo,
} from "../../../interfaces/despacho";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from "@angular/forms";
import { FormTemasComponent } from "../form-temas/form-temas.component";
import { IEntrada } from "../../../interfaces/entradas";
import {
  expandedTipoDespacho,
  setEntradasByEmpresa,
  getFormulariosInfoVobo,
  guardarFormulariosInfoVobo,
  saveTemasDespacho,
  updateTemaDespacho,
  setEntradasByEmpresaSuccess,
} from "../../../states/despacho/actions";
import { TemasService } from "../../../services/temas/temas.service";
import { MatButtonModule } from "@angular/material/button";
import { EntradasService } from "../../../services/entradas/entradas.service";
import { selectUsuario } from "../../../states/usuario/selector";

@Component({
  selector: "app-informativo-vobo",
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatExpansionModule,
    CommonModule,
    FormTemasComponent,
    FormsModule,
    MatButtonModule,
  ],
  templateUrl: "./informativo-vobo.component.html",
  styleUrl: "./informativo-vobo.component.css",
})
export class InformativoVoboComponent {
  @Input() tipoDespacho: number = 0;
  @Input() despachos!: AbstractControl;
  @Input() despacho!: IDespacho;
  currentAccordion!: string;
  private readonly store: Store<AppState> = inject(Store);
  // despachoActual$!: Observable<IDespacho>;
  // despachoActual: IDespacho[] = [];
  // guardando$!: Observable<boolean>;
  // public temasForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private temasService: TemasService,
    private entradasService: EntradasService) {
    // this.temasForm = this.fb.group({
    //   informativo: this.fb.array([]),
    //   vobo: this.fb.array([]),
    // });
  }

  private stateEntradas: any = this.store.pipe(select(selectDespachoEntradas));
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  public listaEntradas: IEntrada[] = [];
  public expanded = "";

  private hasUpdated: boolean = false; // Bandera de control
  async ngOnInit() {
    this.expanded = await this.stateEntradas.state().formaEnvio.currentExpanded;
    this.listaEntradas = await this.stateEntradas.state().formaEnvio.entradas;

    //console.log(" this.listaEntradas", this.listaEntradas);

    // this.despachoActual$ = this.store
    //   .select(selectDespachoActual)
    //   .pipe(take(1));
    // this.despachoActual$.pipe(take(1)).subscribe((data: IDespacho) => {
    //   if (data.Informativo.length > 0) {
    //     this.informativoFormArray.clear();
    //     data.Informativo.forEach((tema) => {
    //       const temaForm = this.crearFormulario(tema);
    //       this.informativoFormArray.push(temaForm);
    //     });
    //   }
    //   if (data.VoBo.length > 0) {
    //     this.voboFormArray.clear();
    //     data.VoBo.forEach((tema, index) => {
    //       const temaForm = this.crearFormulario(tema);
    //       this.voboFormArray.push(temaForm);
    //     });
    //   }
    // });

    // this.temasForm.get("informativo")?.valueChanges.subscribe((informativo) => {
    //   console.log("informativo", informativo);
    //   this.updateTemaDespacho("Informativo", informativo);
    // });
    // this.temasForm.get("vobo")?.valueChanges.subscribe((vobo) => {
    //   console.log("vobo", vobo);
    //   this.updateTemaDespacho("VoBo", vobo);
    // });
    // Dentro de tu OnInit
    // Dentro de tu OnInit
  }

  // crearFormulario(tema: VoBo | Informativo): FormGroup {
  //   return this.fb.group({
  //     id_tema: [tema.id_tema],
  //     id_edo_tema: [tema.id_edo_tema],
  //     nombreTema: [tema.nombreTema, [Validators.required]],
  //     descripcionTema: [tema.descripcionTema],
  //     id_tipo_despacho: [tema.id_tipo_despacho],
  //     indice: [tema.indice],
  //     descripcion: [tema.descripcion],
  //     id_empresa: [tema.id_empresa],
  //     banEsImpreso: [tema.banEsImpreso],
  //     ts_alta_audit: [tema.ts_alta_audit],
  //     nombre_empresa: [tema.nombre_empresa],
  //     entradas: [tema.entradas],
  //     entradaSelected: [
  //       { value: "", disabled: this.listaEntradas.length <= 0 },
  //     ],
  //     marcarParaImpresion: [tema.marcarParaImpresion],
  //     accion: [null],
  //   });
  // }

  // get informativoFormArray(): FormArray {
  //   return this.temasForm.get("informativo") as FormArray;
  // }
  // get voboFormArray(): FormArray {
  //   return this.temasForm.get("vobo") as FormArray;
  // }

  get informativo(): FormGroup {
    return this.despachos.get("informativo") as FormGroup;
  }

  get vobo(): FormGroup {
    return this.despachos.get("vobo") as FormGroup;
  }
  openClose(currentExpanded: string) {
    this.currentAccordion = currentExpanded;
    this.store.dispatch(expandedTipoDespacho({ currentExpanded }));
  }
  save() {
    console.log("this.despachos", this.despachos);

    this.store.dispatch(
      guardarFormulariosInfoVobo({ form: this.despachos.value })
    );
  }

  async getEntradasByEmpresa(id_empresa: string) {

      const user = structuredClone(this.stateUser.state().usuario.temas);
     const temas = Object.keys(user).map((key) => ({
       id_categorizacion: key,
       id_tipo_forma: 2,
       id_empresa,
     }));

    
    try {
        const res = await firstValueFrom(this.entradasService.obtenerEntradas(temas));
      
        this.store.dispatch(setEntradasByEmpresaSuccess({ entradas: res.entradas}));
    } catch (error) {
       this.store.dispatch(setEntradasByEmpresaSuccess({ entradas: [] }));
    }
  
  }
}
